/* eslint-disable complexity */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { omit, values } from 'lodash'
import { Waypoint } from 'react-waypoint'
import { animateScroll as scroll } from 'react-scroll'

import { getHistory } from 'lib/history'
import * as blUrls from 'lib/urls'
import { LoadingHeart } from 'baby-design'
import OfferList from 'components/offer-list/offer-list'
import withCurrentUser from 'shared/HOC/withCurrentUser'
import { track, TrackImpression, tracking } from 'lib/analytics'
import {
  getSearchId,
  PRODUCT_SEARCH_INDEX_KEY,
} from 'shared/hooks/useSearchId/useSearchId'
import css from './product-details-page.scss'

import Breadcrumb from '../store-breadcrumb'
import SelectionControls from './selection-controls'
import PreviewBar from './preview-bar'
import ProductInfo from './product-info'
import ProductImages from './product-images'
import { FavorActions, ProductActions } from './product-actions'
import ProductContentSections from './product-content-sections'
import GiftGiverAction from './gift-giver-action'
import { gtagEvents } from './helpers'
import { getSearchPreviewIds } from 'components/global-nav/components/SearchBar/SearchBar.utils'
import { BreadcrumbExperiment } from 'src/routes/(shop)/gp/[slug]/[genericProductId]/[productId]/components/BreadcrumbExperiment/BreadcrumbExperiment'
import { trackBackToTopClick } from 'src/routes/(shop)/lib/tracking'

const history = getHistory({ useRouter: true })

// define context of any sub tracking event
@tracking((props) => {
  const product = props.genericProduct.products[props.productId]
  product.brand = props.genericProduct.brand
  return {
    product,
    pdpType: props.genericProduct.pdpType,
    eventLocation: track.EventLocation.PDP,
  }
})
class ProductDetailsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mounted: false,
      showPreviewBar: false,
    }
  }

  componentDidMount() {
    this.setState({ mounted: true })

    const product = this.getActiveProduct()

    fbq('track', 'ViewContent', {
      content_type: 'product',
      content_ids: [product.id],
    })

    gtagEvents.addRemarketing(product)
    gtagEvents.trackConversion()

    this.PubSub = () => {
      try {
        return window.PubSub
      } catch (e) {}
      return { publish: function (message, payload) {} }
    }
  }

  componentDidUpdate(prevProps) {
    /**
     * Need to track active category which is fetched async after page load.
     * Want to avoid any kind of fallback and accidentally send multiple pixel events.
     */
    const productHasChanged = prevProps.productId !== this.props.productId
    const activeCategoryHasChanged =
      // eslint-disable-next-line react/prop-types
      prevProps.activeCategory?.title !== this.props.activeCategory?.title
  }

  handleProductChange(productId) {
    if (this.props.productId !== productId) {
      const gp = this.props.genericProduct
      history.replace({
        pathname: blUrls.pdpPath(gp.slug, gp.id, productId),

        state: { slugSet: this.props.slugSet },
      })
    }
  }

  handleWaypointEvent({ currentPosition }) {
    if (currentPosition == 'above') {
      this.setState({ showPreviewBar: true })
    } else {
      this.setState({ showPreviewBar: false })
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleClickPreviewBar(tracker) {
    return () => {
      scroll.scrollToTop()
      trackBackToTopClick(tracker.trackEvent)
    }
  }

  getActiveProduct() {
    return this.getProduct(this.props.productId)
  }

  getProduct(productId) {
    return this.props.genericProduct.products[productId]
  }

  getAllReviewSkus() {
    const products = values(this.props.genericProduct.products)
    return products.map((p) => p.turntoSku)
  }

  productPath(productId) {
    const gp = this.props.genericProduct
    return blUrls.pdpPath(gp.slug, gp.id, productId)
  }

  renderProductDetails(showReviews) {
    const { mounted } = this.state
    if (!mounted) return null

    const gp = this.props.genericProduct
    const activeProduct = this.getActiveProduct()

    return (
      <div className="container mtl mtxl-sm">
        {gp.details /* assume we are loading if details is missing */ ? (
          <ProductContentSections
            allReviewSkus={this.getAllReviewSkus()}
            details={gp.details}
            genericProductId={gp.id}
            guides={this.props.guides}
            recommendedProducts={this.props.recommendedProducts}
            reviewSku={activeProduct.turntoSku}
            reviews={gp.reviews}
            showReviews={showReviews}
            videos={gp.videos}
          />
        ) : (
          <LoadingHeart className={css.loading} />
        )}
      </div>
    )
  }

  renderBreadcrumb({ gp, activeProduct }) {
    const { show_new_breadcrumb_and_hide_categories } = this.props.featureFlags

    if (show_new_breadcrumb_and_hide_categories) {
      return (
        <>
          <div className="hidden-xs">
            <Breadcrumb
              activeSlugSet={this.props.slugSet}
              product={{
                path: blUrls.pdpPath(gp.slug, gp.id, activeProduct.id),
                name: gp.name,
              }}
            />
          </div>
          <div className="visible-xs">
            <BreadcrumbExperiment genericProduct={gp} />
          </div>
        </>
      )
    } else {
      return (
        <Breadcrumb
          activeSlugSet={this.props.slugSet}
          product={{
            path: blUrls.pdpPath(gp.slug, gp.id, activeProduct.id),
            name: gp.name,
          }}
        />
      )
    }
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { brandPageUrl, userEmail, currentUser } = this.props

    const gp = this.props.genericProduct
    const activeProduct = this.getActiveProduct()
    const showReviews =
      !activeProduct.isElectronicGiftCard &&
      !activeProduct.isFavor &&
      !activeProduct.isCashFund &&
      !activeProduct.isCrowdfund
    const showPrice =
      !activeProduct.isCashFund &&
      !activeProduct.isFavor &&
      !activeProduct.isCrowdfund
    const message = activeProduct.merchandisingMessage

    const isGiftable =
      activeProduct.approved &&
      !activeProduct.isCashFund &&
      !activeProduct.isFavor &&
      !activeProduct.isCrowdfund

    const showGiftGiverActions = isGiftable && this.props.regItemId
    const showAddToCartButton = isGiftable && !showGiftGiverActions
    const showInStockNotificationLink =
      showAddToCartButton &&
      userEmail &&
      activeProduct.allowAvailabilitySubscription &&
      !activeProduct.availabilityMessage
    const showBreastPumpCta = gp.showBabylistHealthCta && !showGiftGiverActions

    const searchId = getSearchId(PRODUCT_SEARCH_INDEX_KEY)
    const searchPreviewIds = getSearchPreviewIds()
    const currentUrl =
      typeof window === 'undefined' ? '' : window?.location?.href

    return (
      <TrackImpression
        eventFireCondition={currentUrl}
        eventProperties={{
          event: track.pdpViewed,
          searchId,
          searchPreviewIds,
          inStockSoonMessage: activeProduct.babylistMerchandiseNotInStock,
          isFsaHsaEligible: activeProduct.fsaHsaEligible,
        }}
      >
        <div>
          {!activeProduct.isFavor ? (
            <PreviewBar
              availabilityMessage={message}
              brand={gp.brand}
              imageUrl={activeProduct.images[0] && activeProduct.images[0].url}
              isElectronicGiftCard={activeProduct.isElectronicGiftCard}
              name={gp.shortName}
              path={blUrls.pdpPath(gp.slug, gp.id, activeProduct.id)}
              price={activeProduct.price}
              rating={gp.rating}
              reviewCount={gp.reviewCount}
              show={this.state.showPreviewBar}
              showPrice={showPrice}
              showReviews={showReviews}
              onClick={this.handleClickPreviewBar(this.props.tracking)}
            />
          ) : null}
          <div className="container">
            {this.renderBreadcrumb({ activeProduct, gp })}
          </div>
          <div className={css.mainContent}>
            <div className="container">
              <Row className={css.flexContainer}>
                <Col className={css.imagesContainer} md={8}>
                  <ProductImages
                    images={activeProduct.images.slice(0, 7)}
                    video={gp.videos[0]}
                  />
                </Col>
                <Col className={css.productInfoContainer} md={4}>
                  <ProductInfo
                    brand={gp.brand}
                    brandPageUrl={brandPageUrl}
                    callouts={activeProduct.callouts}
                    extendedDeliveryTimeMessage={
                      activeProduct.extendedDeliveryTimeMessage
                    }
                    isElectronicGiftCard={activeProduct.isElectronicGiftCard}
                    merchandisingMessage={message}
                    name={
                      activeProduct.isElectronicGiftCard
                        ? gp.name
                        : gp.shortName
                    }
                    path={blUrls.pdpPath(gp.slug, gp.id, activeProduct.id)}
                    price={activeProduct.price}
                    productId={activeProduct.id}
                    productType={activeProduct.productType}
                    rating={gp.rating}
                    reviewCount={gp.reviewCount}
                    reviewSku={activeProduct.turntoSku}
                    showInStockNotificationLink={showInStockNotificationLink}
                    showPrice={showPrice}
                    showReviews={showReviews}
                    surchargeModalPrompt={activeProduct.surchargeModalPrompt}
                  />
                  <hr className="mvm" />
                  {currentUser?.admin ? (
                    <div>
                      <a
                        className="small"
                        href={blUrls.blAdminProductPath(
                          gp.id,
                          activeProduct.id
                        )}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Admin Page
                      </a>
                      <hr className="mvm" />
                    </div>
                  ) : null}

                  {showGiftGiverActions ? (
                    <GiftGiverAction
                      regItemId={this.props.regItemId}
                      registryId={this.props.registryId}
                    />
                  ) : null}

                  <SelectionControls
                    allAttributes={gp.attributes}
                    attributeLabelOverrides={
                      activeProduct.isCashFund ? { amount: 'goal' } : null
                    }
                    /* eslint-disable-next-line react/jsx-no-bind */
                    productAttributeMap={gp.productAttributeMap}
                    productName={gp.name}
                    productPath={this.productPath.bind(this)}
                    products={gp.products}
                    onProductChange={this.handleProductChange.bind(this)}
                    selectedAttributes={omit(
                      activeProduct.attributes,
                      'sizeOnCatalog'
                    )}
                  />
                  {/* TODO: break out into a getActions helper */}
                  {activeProduct.approved && activeProduct.isFavor && (
                    <FavorActions
                      PubSub={PubSub}
                      addToRegistry={this.props.addToRegistry}
                      addedToRegistry={this.props.addedToRegistry}
                      currentRegistryTitle={currentUser?.currentRegistry?.title}
                      currentRegistryUrlSlug={
                        currentUser?.currentRegistry?.urlSlug
                      }
                      currentUserPresent={!!currentUser}
                      favor={activeProduct.name}
                    />
                  )}
                  {activeProduct.approved && !activeProduct.isFavor ? (
                    <ProductActions
                      addProductAvailabilitySubscription={
                        this.props.addProductAvailabilitySubscription
                      }
                      addToCart={this.props.addToCart}
                      addToRegistry={this.props.addToRegistry}
                      addedToCart={this.props.addedToCart}
                      addedToRegistry={this.props.addedToRegistry}
                      cashFundPreferences={this.props.cashFundPreferences}
                      currentUser={currentUser}
                      isRegistryOwner={this.props.isRegistryOwner}
                      key={activeProduct.id}
                      product={activeProduct}
                      productName={gp.name}
                      regItemId={this.props.regItemId}
                      registryId={this.props.registryId}
                      saveCashFundPreferences={
                        this.props.saveCashFundPreferences
                      }
                      showAddToCartButton={showAddToCartButton}
                      showBreastPumpCta={showBreastPumpCta}
                      userEmail={this.props.userEmail}
                      userIsAdmin={!!currentUser?.admin}
                      PubSub={PubSub}
                      /* eslint-disable-next-line react/prop-types */
                      activeCategory={this.props.activeCategory}
                    />
                  ) : null}
                  {!activeProduct.availableOnBabylist &&
                  activeProduct.otherBuyingOptions &&
                  activeProduct.otherBuyingOptions.length ? (
                    <OfferList
                      isContributorView
                      className={css.offersContainer}
                      limit={3}
                      offers={activeProduct.otherBuyingOptions}
                    />
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
          <Waypoint
            /* eslint-disable-next-line react/jsx-no-bind */
            onEnter={this.handleWaypointEvent.bind(this)}
            /* eslint-disable-next-line react/jsx-no-bind */
            onLeave={this.handleWaypointEvent.bind(this)}
          />
          {this.renderProductDetails(showReviews)}
        </div>
      </TrackImpression>
    )
  }
}

ProductDetailsPage.propTypes = {
  addProductAvailabilitySubscription: PropTypes.func,
  addToCart: PropTypes.func,
  addToRegistry: PropTypes.func,
  addedToCart: PropTypes.bool,
  addedToRegistry: PropTypes.bool,
  cashFundPreferences: PropTypes.object,
  currentUser: PropTypes.object,
  genericProduct: PropTypes.object,
  guides: PropTypes.array,
  isRegistryOwner: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  isGroupGift: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  maybeFetchProducts: PropTypes.func,
  productId: PropTypes.number,
  slugSet: PropTypes.array,
  regItemId: PropTypes.number,
  registryId: PropTypes.number,
  saveCashFundPreferences: PropTypes.func.isRequired,
  userEmail: PropTypes.string,
}

export default withCurrentUser(ProductDetailsPage)
